import { Select } from 'antd';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
	border-radius: 4px;
`;

export const StyledCreateChannelOption = styled.div`
	color: var(--bg-robin-500);
	display: flex;
	align-items: center;
	gap: 8px;
`;
